<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div class="d-flex ">
          <div class="perma-section-input pl-2">{{input}}</div>
          <div>
            <v-btn class="ex-remove-btn w-100 ma-0 mb-2" @click="remove()" color="error" dark large>Remove Chain</v-btn>
            <div class="perma-section text-center pt-3 pb-3">{{method}}</div>
            <div class="selector_chainlink list-group-item bg-primary text-white">
              <div class="chin-edit">
                <v-btn
                  text
                  class="m-w chin-edit-icon"
                  @click="showExtractDialog()"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </div>
              <div class="i-v-input">
                <div>Extract Block</div>
              </div>
            </div>
            <v-btn class="ex-add-btn  w-100 ma-0 mt-2" @click="add()" color="success" dark large>Add Chain</v-btn>
          </div>
          <div class="perma-section-output pr-2">{{output}}</div>
        </div>
      </v-flex>
    </v-layout>
    <!--    Dialog -->
    <v-dialog
      v-model="showExtractBlock"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline"
          dark-title
        >
          Extract
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mb-3">
          <ex-card disable-offsets >
            <template slot="header" >
              <span class="label">Source: </span>
              <v-select
                v-model="source"
                :items="source_options"
                label="No selection"
                class="ex-dropdown"
                item-text="text"
                solo
              ></v-select>
              <div v-if="method === 'standard'" class="row">
                <div class="col" v-for="(data, idx) in methods.json" :key=idx></div>
              </div>
              <div v-if="method === 'standard'" class="row">
                <v-btn @click="moreJSON">More Json</v-btn>
                <div class="col" v-for="(data, idx) in methods.json" :key=idx>
                  <span class="label">Add Subroutine: </span>
                  <br />
                  <div>
                    <v-btn @click="findBlockSub(data)">Add findBlock</v-btn>
                    <v-btn @click="removeSub(data)">Add remove</v-btn>
                    <v-btn @click="countSub(data)">Add count</v-btn>
                  </div>
                  <div class="col" v-for="(subroutine, idxS) in data.subroutines" :key=idxS>
                    <div v-show="subroutine.type == 'findBlockSub'">
                      Find Element
                      <br />
                      <v-text-field v-model="subroutine.input" placeholder="Input"/>
                      <v-text-field v-model="subroutine.property" placeholder="Property"/>
                      <v-text-field v-model="subroutine.value" placeholder="Value"/>
                      <v-text-field v-show="false" v-model="subroutine.return" placeholder="Return"/>
                     </div>
                    <div v-show="subroutine.type == 'removeSub'">
                      Remove Element
                      <br />
                      <v-text-field v-model="subroutine.input" placeholder="Input"/>
                      <v-text-field v-model="subroutine.property" placeholder="Property"/>
                      <v-text-field v-model="subroutine.value" placeholder="Value"/>
                      <v-text-field v-show="false" v-model="subroutine.return" placeholder="Return"/>
                    </div>
                    <div v-show="subroutine.type == 'countSub'">
                      Count Elements
                      <br />
                      <v-text-field v-model="subroutine.input" placeholder="Input"/>
                      <v-text-field v-model="subroutine.property" placeholder="Property"/>
                      <v-text-field v-model="subroutine.value" placeholder="Value"/>
                      <v-text-field v-show="false" v-model="subroutine.return" placeholder="Return"/>
                    </div>
                    <v-btn @click="data.subroutines.splice(idxS, 1)">Remove</v-btn>
                  </div>
                  <v-text-field v-model="data.path" placeholder="path json"/>
                  <v-text-field v-model="data.result" @change="jsonChange(idx)" placeholder="result"/>
                  <v-checkbox
                    v-model="data.database"
                    label="Save to database"
                  ></v-checkbox>
                  <br />
                </div>
              </div>
              <div v-if="method === 'dom'" class="row">
                  <div class="col" v-for="(data, idx) in methods.dom" :key=idx>
                      <v-btn @click="removeDom(idx)" v-if="domShowRemove(idx)">Remove</v-btn>
                      <br />
                      <span class="label">CSS Path: </span>
                      <v-select
                        v-model="data.return.selected"
                        :items="data.return.available"
                        @change="domCheckP1(idx)"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                      <span v-show="['retrieve','empty'].includes(data.return.selected)">
                        <v-text-field v-model="data.path" placeholder="path"/>
                        <v-text-field v-model="data.attribute" placeholder="attribute"/>
                        <v-text-field v-if="data.single" v-model="data.occurrence" placeholder="occurrence"/>
                        <v-checkbox
                          v-model="data.single"
                          label="Single Result"
                        ></v-checkbox>
                      </span>
                      <span v-show="['match list'].includes(data.return.selected)">
                        <v-text-field v-model="data.path" placeholder="Match Path"/>
                        <v-text-field v-model="data.value" placeholder="Value"/>
                        <v-checkbox
                          v-model="data.exact"
                          label="Exact Match"
                        ></v-checkbox>
                        <v-text-field v-model="data.backtrack" placeholder="No of backtracks"/>
                      </span>
                      <span v-show="['count'].includes(data.return.selected)">
                        <v-text-field v-model="data.path" placeholder="Match Path"/>
                        <v-text-field v-model="data.inner_path" placeholder="Inner Path"/>
                        <v-text-field v-model="data.value" placeholder="Value"/>
                        <v-checkbox
                          v-model="data.exact"
                          label="Exact Match"
                        ></v-checkbox>
                        <v-text-field v-model="data.backtrack" placeholder="No of backtracks"/>
                      </span>
                      <v-btn @click="moreDOM" v-show="domShowExtend(idx)">Extend if empty</v-btn>
                      <span class="label">Save as custom variable:</span>
                      <v-text-field v-model="data.customvariable" placeholder="variable name"/>
                      <!-- <v-btn @click="addcustomvariable(data.customvariable)" v-if="data.customvariable != ''">Add</v-btn> -->
                  </div>
                <div class="col" v-show="result.length > 0">{{result}}</div>
            </div>
              <div v-if="method === 'regex'" class="row">
                  <div class="col" v-for="(data, idx) in methods.regex" :key=idx>
                      <span class="label">Regex: </span>
                      <v-text-field v-model="data.delimiter" placeholder="Delimiter"/>
                      <v-text-field v-model="data.body" placeholder="expression"/>
                      <v-text-field v-model="data.options" placeholder="Options"/>
                      <v-checkbox
                        v-model="data.single"
                        label="Single Result"
                      ></v-checkbox>
                  </div>
                <div class="col" v-show="result.length > 0">{{result}}</div>
            </div>
            </template>
          </ex-card>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  name: 'Extract',
  props: ['x', 'y', 'variables'],
  data: () => ({
    showExtractBlock: false,
    single: true,
    templates: {
      dom: {return: {available: ['match list', 'empty', 'retrieve', 'count'], selected: 'retrieve'}, value: '', inner_path: '', backtrack: '', path: '', occurrence: '', attribute: '', single: true, exact: true, subroutines: []},
      regex: {delimiter: '@', body: '', options: '', single: true},
      json: {path: '', result: '', database: false, subroutines: []}
    },
    methods: {
      dom: [],
      regex: [],
      json: []
    },
    source_options: ['input'],
    my_variables: [],
    path: '',
    occurrence: 0,
    attribute: '',
    destroy: false,
    result: '',
    source: 'input',
    input: '',
    method: '',
    output: ''
  }),
  methods: {
    findBlockSub (data) {
      data.subroutines.push({type: 'findBlockSub'})
    },
    removeSub (data) {
      data.subroutines.push({type: 'removeSub'})
    },
    countSub (data) {
      data.subroutines.push({type: 'countSub'})
    },
    jsonChange (idx) {
      this.my_variables[idx] = {id: this.methods.json[idx].result, value: this.methods.json[idx].path}
      this.addGlobalVars()
    },
    domCheckP1 (idx) {
      var selected = this.methods.dom[idx].return.selected
      var length = this.methods.dom.length

      if (selected === 'empty') {
        this.moreDOM()
      } else if (selected === 'retrieve') {
        if (length > 1) {
          this.methods.dom.pop()
          this.$set(this.methods, 'dom', this.methods.dom)
        }
      }
    },
    domShowExtend (idx) {
      var selected = this.methods.dom[idx].return.selected
      var length = this.methods.dom.length

      if (selected === 'empty') {
        return false
      }

      if (length !== idx + 1) {
        return false
      }

      return true
    },
    domShowRemove (idx) {
      if (idx === 0) {
        return false
      }

      return true
    },
    removeDom (idx) {
      this.methods.dom.splice(idx, 1)
    },
    moreJSON () {
      this.methods.json.push(JSON.parse(JSON.stringify(this.templates.json)))
    },
    moreDOM () {
      this.methods.dom.push(JSON.parse(JSON.stringify(this.templates.dom)))
    },
    add () {
      this.$emit('add', this.y, this.x)
    },
    remove () {
      this.$emit('remove', this.y, this.x)
    },
    showExtractDialog () {
      this.showExtractBlock = true
    },
    addGlobalVars () {
      this.$emit('addGlobalVars', this.y, this.x, this.my_variables)
    },
    addcustomvariable (variable) {
      this.$emit('addGlobalVars', this.y, this.x, [variable])
    }
  },
  computed: {},
  created () {
    this.moreDOM()
    this.moreJSON()
    this.methods.regex.push(this.templates.regex)
    for (let i = 0; i < this.variables.length; i++) {
      this.source_options.push(this.variables[i].id)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/selector/Extract.vue